module.exports = __webpack_public_path__ + "img/map-icon-brewery.c9e26a65.png";